document.addEventListener('DOMContentLoaded', function () {
  var navToggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav-links]');
  if (navToggle && nav) navToggle.addEventListener('click', function(){ nav.classList.toggle('is-open'); });

  document.querySelectorAll('[data-category-dropdown]').forEach(function(dropdown){
    document.addEventListener('click', function(e){
      if (!dropdown.contains(e.target)) dropdown.removeAttribute('open');
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape') dropdown.removeAttribute('open');
    });
  });


  var searchToggle = document.querySelector('[data-search-toggle]');
  var search = document.querySelector('[data-header-search]');
  var searchBackdrop = document.createElement('div');
  searchBackdrop.className = 'search-backdrop';
  document.body.appendChild(searchBackdrop);
  function closeSearch(){ if (search) search.classList.remove('is-open'); searchBackdrop.classList.remove('is-open'); }
  function openSearch(){ if (!search) return; search.classList.add('is-open'); searchBackdrop.classList.add('is-open'); var input = search.querySelector('input[name="q"]'); if (input) setTimeout(function(){ input.focus(); }, 50); }
  if (searchToggle && search) searchToggle.addEventListener('click', function(e){ e.stopPropagation(); search.classList.contains('is-open') ? closeSearch() : openSearch(); });
  searchBackdrop.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeSearch(); });
  if (search) search.addEventListener('click', function(e){ e.stopPropagation(); });

  document.querySelectorAll('[data-smart-search]').forEach(function(form){
    form.querySelectorAll('[data-remove-line]').forEach(function(button){
      button.addEventListener('click', function(){
        var row = button.closest('[data-cart-line]');
        if (!row) return;
        var key = row.getAttribute('data-line-key');
        if (!key) return;
        button.disabled = true;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(function(){ window.location.reload(); })
          .catch(function(){ button.disabled = false; });
      });
    });

    form.addEventListener('submit', function(e){
      var input = form.querySelector('input[name="q"]');
      if (!input) return;
      var clean = input.value.trim();
      if (!clean) { e.preventDefault(); window.location.href = '/collections/all'; return; }
      var expanded = clean.split(/\s+/).map(function(term){ return term.indexOf('*') > -1 ? term : term + '*'; }).join(' ');
      input.value = expanded;
      var sortInput = form.querySelector('input[name="sort_by"]');
      if (!sortInput) {
        sortInput = document.createElement('input');
        sortInput.type = 'hidden';
        sortInput.name = 'sort_by';
        form.appendChild(sortInput);
      }
      sortInput.value = 'title-ascending';
    });
  });

  document.querySelectorAll('[data-quick-order]').forEach(function(form){
    form.querySelectorAll('[data-remove-line]').forEach(function(button){
      button.addEventListener('click', function(){
        var row = button.closest('[data-cart-line]');
        if (!row) return;
        var key = row.getAttribute('data-line-key');
        if (!key) return;
        button.disabled = true;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(function(){ window.location.reload(); })
          .catch(function(){ button.disabled = false; });
      });
    });

    form.addEventListener('submit', function(e){
      e.preventDefault();
      var terms = Array.prototype.slice.call(form.querySelectorAll('[data-sku]')).map(function(i){return i.value.trim();}).filter(Boolean).join(' ');
      if (!terms) { window.location.href = '/collections/all'; return; }
      var expanded = terms.split(/\s+/).map(function(term){ return term + '*'; }).join(' ');
      window.location.href = '/search?type=product&sort_by=title-ascending&q=' + encodeURIComponent(expanded);
    });
  });

  function formatMoneyFromCents(cents) {
    var amount = (Math.round(cents) / 100).toFixed(2);
    return '$' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  document.querySelectorAll('[data-cart-form]').forEach(function(form){
    var qtyInputs = Array.prototype.slice.call(form.querySelectorAll('[data-cart-qty]'));
    var totalEl = form.querySelector('[data-cart-total]');
    var gstEl = form.querySelector('[data-gst-total]');
    var grossEl = form.querySelector('[data-gross-total]');

    function updateCartTotals(cartTotal){
      // Product prices are GST-inclusive. GST included is 1/11 of the gross total.
      var gst = Math.round(cartTotal / 11);
      var gross = cartTotal;
      if (totalEl) totalEl.textContent = formatMoneyFromCents(cartTotal);
      if (gstEl) gstEl.textContent = formatMoneyFromCents(gst);
      if (grossEl) grossEl.textContent = formatMoneyFromCents(gross);
    }

    function recalcCart(){
      var cartTotal = 0;
      form.querySelectorAll('[data-cart-line]').forEach(function(row){
        var unit = parseInt(row.getAttribute('data-unit-price') || '0', 10);
        var qtyInput = row.querySelector('[data-cart-qty]');
        var qty = qtyInput ? Math.max(parseInt(qtyInput.value || '0', 10), 0) : 0;
        var lineTotal = unit * qty;
        cartTotal += lineTotal;
        var lineEl = row.querySelector('[data-line-total]');
        if (lineEl) lineEl.textContent = formatMoneyFromCents(lineTotal);
      });
      updateCartTotals(cartTotal);
    }

    var updateTimer;
    function persistCartQuantities(){
      var updates = qtyInputs.map(function(input){ return Math.max(parseInt(input.value || '0', 10), 0); });
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function(response){ return response.json(); })
        .then(function(cart){
          if (!cart) return;
          updateCartTotals(cart.total_price || 0);
          var cartPill = document.querySelector('.cart-pill');
          if (cartPill) cartPill.textContent = 'Cart (' + (cart.item_count || 0) + ')';
        })
        .catch(function(){ /* keep the live local total visible if Shopify update fails */ });
    }

    qtyInputs.forEach(function(input){
      input.addEventListener('input', function(){
        recalcCart();
        clearTimeout(updateTimer);
        updateTimer = setTimeout(persistCartQuantities, 550);
      });
      input.addEventListener('change', function(){
        recalcCart();
        clearTimeout(updateTimer);
        persistCartQuantities();
      });
    });

    var clearCartButton = form.querySelector('[data-clear-cart]');
    if (clearCartButton) {
      clearCartButton.addEventListener('click', function(){
        if (!confirm('Delete all items from the cart?')) return;
        fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
          .then(function(){ window.location.reload(); })
          .catch(function(){ window.location.href = '/cart/clear'; });
      });
    }

    form.querySelectorAll('[data-remove-line]').forEach(function(button){
      button.addEventListener('click', function(){
        var row = button.closest('[data-cart-line]');
        if (!row) return;
        var key = row.getAttribute('data-line-key');
        if (!key) return;
        button.disabled = true;
        row.classList.add('is-removing');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(function(response){ return response.json(); })
          .then(function(cart){
            if (!cart) { window.location.reload(); return; }
            var cartPill = document.querySelector('.cart-pill');
            if (cartPill) cartPill.textContent = 'Cart (' + (cart.item_count || 0) + ')';
            if ((cart.item_count || 0) === 0) { window.location.reload(); return; }
            row.remove();
            qtyInputs = Array.prototype.slice.call(form.querySelectorAll('[data-cart-qty]'));
            updateCartTotals(cart.total_price || 0);
          })
          .catch(function(){
            row.classList.remove('is-removing');
            button.disabled = false;
          });
      });
    });

    form.addEventListener('submit', function(e){
      var submitter = e.submitter;
      if (!submitter || !submitter.matches('[data-checkout-button]')) return;
      e.preventDefault();
      var updates = qtyInputs.map(function(input){ return Math.max(parseInt(input.value || '0', 10), 0); });
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function(){ window.location.href = '/checkout'; })
        .catch(function(){ form.submit(); });
    });
  });


  

  var slideshow = document.querySelector('[data-home-slideshow]');
  if (slideshow) {
    var slides = Array.prototype.slice.call(slideshow.querySelectorAll('.home-slide'));
    var dots = Array.prototype.slice.call(slideshow.querySelectorAll('[data-slide-dot]'));
    var prevButton = slideshow.querySelector('[data-slide-prev]');
    var nextButton = slideshow.querySelector('[data-slide-next]');
    var currentSlide = 0;
    var slideTimer;

    function goToSlide(index) {
      if (!slides.length) return;
      currentSlide = (index + slides.length) % slides.length;
      slides.forEach(function(slide, i){ slide.classList.toggle('is-active', i === currentSlide); });
      dots.forEach(function(dot, i){ dot.classList.toggle('is-active', i === currentSlide); });
    }
    function startSlides() {
      if (slides.length < 2) return;
      clearInterval(slideTimer);
      slideTimer = setInterval(function(){ goToSlide(currentSlide + 1); }, 4500);
    }

    dots.forEach(function(dot, i){
      dot.addEventListener('click', function(){ goToSlide(i); startSlides(); });
    });
    if (prevButton) prevButton.addEventListener('click', function(){ goToSlide(currentSlide - 1); startSlides(); });
    if (nextButton) nextButton.addEventListener('click', function(){ goToSlide(currentSlide + 1); startSlides(); });

    slideshow.addEventListener('mouseenter', function(){ clearInterval(slideTimer); });
    slideshow.addEventListener('mouseleave', startSlides);
    goToSlide(0);
    startSlides();
  }



  document.querySelectorAll('[data-qty-stepper]').forEach(function(stepper){
    stepper.setAttribute('data-qty-bound', 'true');
    var input = stepper.querySelector('input[type="number"]');
    var minus = stepper.querySelector('[data-qty-minus]');
    var plus = stepper.querySelector('[data-qty-plus]');
    if (!input) return;
    function setQty(value){
      var min = parseInt(input.getAttribute('min') || '1', 10);
      var qty = Math.max(parseInt(value || min, 10), min);
      input.value = qty;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (minus) minus.addEventListener('click', function(){ setQty((parseInt(input.value || '1', 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function(){ setQty((parseInt(input.value || '1', 10) || 1) + 1); });
  });

  function handleAjaxAddToCart(form, messageSelector){
    var button = form.querySelector('button[type="submit"]');
    var message = form.querySelector(messageSelector || '[data-cart-message]');
    if (message) message.textContent = '';
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    var formData = new FormData(form);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
    .then(function(response){
      if (!response.ok) throw new Error('Could not add item');
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    })
    .then(function(response){ return response.json(); })
    .then(function(cart){
      var cartPill = document.querySelector('.cart-pill');
      if (cartPill) cartPill.textContent = 'Cart (' + (cart.item_count || 0) + ')';
      if (message) message.textContent = 'Cart updated';
    })
    .catch(function(){
      if (message) message.textContent = 'Could not update cart. Please try again.';
    })
    .finally(function(){
      if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
    });
  }

  document.querySelectorAll('[data-quick-add-form]').forEach(function(form){
    form.setAttribute('data-quick-add-bound', 'true');
    form.querySelectorAll('[data-remove-line]').forEach(function(button){
      button.addEventListener('click', function(){
        var row = button.closest('[data-cart-line]');
        if (!row) return;
        var key = row.getAttribute('data-line-key');
        if (!key) return;
        button.disabled = true;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(function(){ window.location.reload(); })
          .catch(function(){ button.disabled = false; });
      });
    });

    form.addEventListener('submit', function(e){
      e.preventDefault();
      handleAjaxAddToCart(form, '[data-quick-add-message]');
    });
  });

  document.addEventListener('submit', function(e){
    var form = e.target.closest && e.target.closest('[data-quick-add-form]');
    if (!form || form.getAttribute('data-quick-add-bound') === 'true') return;
    e.preventDefault();
    handleAjaxAddToCart(form, '[data-quick-add-message]');
  });

  document.addEventListener('click', function(e){
    var button = e.target.closest && e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!button) return;
    var stepper = button.closest('[data-qty-stepper]');
    if (!stepper || stepper.getAttribute('data-qty-bound') === 'true') return;
    var input = stepper.querySelector('input[type="number"]');
    if (!input) return;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var current = parseInt(input.value || min, 10) || min;
    var next = button.matches('[data-qty-minus]') ? current - 1 : current + 1;
    input.value = Math.max(next, min);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });


document.querySelectorAll('[data-ajax-product-form]').forEach(function(form){
    form.querySelectorAll('[data-remove-line]').forEach(function(button){
      button.addEventListener('click', function(){
        var row = button.closest('[data-cart-line]');
        if (!row) return;
        var key = row.getAttribute('data-line-key');
        if (!key) return;
        button.disabled = true;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(function(){ window.location.reload(); })
          .catch(function(){ button.disabled = false; });
      });
    });

    form.addEventListener('submit', function(e){
      e.preventDefault();
      handleAjaxAddToCart(form, '[data-cart-message]');
    });
  });


  // Recently viewed products (local browser storage only)
  (function(){
    var storageKey = 'gnt_recently_viewed_products';
    var maxItems = 5;

    function readHandles(){
      try {
        var parsed = JSON.parse(localStorage.getItem(storageKey) || '[]');
        return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
      } catch(e) { return []; }
    }

    function saveHandles(handles){
      try { localStorage.setItem(storageKey, JSON.stringify(handles.slice(0, maxItems))); } catch(e) {}
    }

    function money(cents){
      if (typeof cents !== 'number') cents = parseInt(cents || '0', 10);
      return '$' + (cents / 100).toFixed(2);
    }

    function renderProduct(product){
      var image = product.featured_image || (product.images && product.images[0]) || '';
      var vendor = product.vendor ? '<div class="muted product-card__vendor">' + escapeHtml(product.vendor) + '</div>' : '';
      var price = product.price ? '<div class="price">' + money(product.price) + '</div>' : '';
      var imageHtml = image ? '<img src="' + image + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '';
      var variants = product.variants || [];
      var variant = variants.find(function(item){ return item.available; }) || variants[0] || null;
      var variantId = variant ? variant.id : '';
      var available = !!(product.available && variant && variant.available);
      var buttonText = 'Quick add';
      var disabled = '';
      var form = variantId ? '<form class="quick-add-form" data-quick-add-form>' +
        '<input type="hidden" name="id" value="' + variantId + '">' +
        '<div class="qty-stepper qty-stepper--small" data-qty-stepper>' +
          '<button class="qty-stepper__btn qty-stepper__btn--minus" type="button" data-qty-minus aria-label="Decrease quantity">−</button>' +
          '<input class="qty-stepper__input" name="quantity" type="number" min="1" value="1" aria-label="Quantity">' +
          '<button class="qty-stepper__btn qty-stepper__btn--plus" type="button" data-qty-plus aria-label="Increase quantity">+</button>' +
        '</div>' +
        '<button class="btn quick-add-btn" type="submit"' + disabled + '>' + buttonText + '</button>' +
        '<div class="quick-add-message" data-quick-add-message role="status" aria-live="polite"></div>' +
      '</form>' : '';
      return '<article class="product-card" data-product-card>' +
        '<a class="product-card__link" href="/products/' + encodeURIComponent(product.handle) + '" aria-label="View ' + escapeHtml(product.title) + '">' +
          '<div class="product-card__image">' + imageHtml + '</div>' +
        '</a>' +
        '<div class="product-card__body">' +
          '<a class="product-card__title" href="/products/' + encodeURIComponent(product.handle) + '">' + escapeHtml(product.title) + '</a>' + vendor + price + form +
        '</div>' +
      '</article>';
    }

    function escapeHtml(value){
      return String(value || '').replace(/[&<>"]/g, function(ch){
        return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[ch]);
      });
    }

    var currentContainer = document.querySelector('[data-current-product-handle]');
    var currentHandle = currentContainer ? currentContainer.getAttribute('data-current-product-handle') : '';
    var handles = readHandles();

    if (currentHandle) {
      handles = handles.filter(function(handle){ return handle !== currentHandle; });
      handles.unshift(currentHandle);
      saveHandles(handles);
    }

    var displayHandles = handles.filter(function(handle){ return handle && handle !== currentHandle; }).slice(0, maxItems);
    var sections = Array.prototype.slice.call(document.querySelectorAll('[data-recently-viewed-section]'));
    if (!sections.length || !displayHandles.length) return;

    Promise.all(displayHandles.map(function(handle){
      // Reuse the shared product card for consistent styling and Shopify availability.
      return fetch('/products/' + encodeURIComponent(handle) + '?view=recent-card', { headers: { 'Accept': 'text/html' } })
        .then(function(response){ if (!response.ok) throw new Error('Not found'); return response.text(); })
        .then(function(html){ return html && html.indexOf('product-card') > -1 ? html : null; })
        .catch(function(){ return null; });
    })).then(function(cards){
      cards = cards.filter(Boolean);
      if (!cards.length) return;
      sections.forEach(function(section){
        var list = section.querySelector('[data-recently-viewed-list]');
        if (!list) return;
        list.innerHTML = cards.join('');
        section.hidden = false;
      });
    });
  })();


  document.querySelectorAll('[data-map-query]').forEach(function(button){
    button.addEventListener('click', function(){
      var section = button.closest('.store-map-section');
      var iframe = section ? section.querySelector('[data-store-map]') : null;
      if (!iframe) return;

      // Keep the embedded Google My Maps view active so all 3 location pins stay visible.
      // Previous versions swapped the iframe to a single-location Google Maps search, which lost the multi-pin map.
      var defaultMap = iframe.getAttribute('data-default-map-src') || iframe.getAttribute('src');
      if (defaultMap && iframe.getAttribute('src') !== defaultMap) iframe.setAttribute('src', defaultMap);

      iframe.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });




  document.querySelectorAll('[data-catalog-page]').forEach(function(page){
    var viewButtons = page.querySelectorAll('[data-view-toggle]');
    var brandChecks = page.querySelectorAll('[data-brand-filter]');
    var clearBrands = page.querySelector('[data-clear-brand-filter]');
    var brandSearch = page.querySelector('[data-brand-search]');
    var cards = Array.prototype.slice.call(page.querySelectorAll('[data-product-card]'));
    var sortSelect = page.querySelector('[data-catalog-sort]');

    function setView(view){
      if (view !== 'list') view = 'grid';
      page.classList.toggle('is-list-view', view === 'list');
      viewButtons.forEach(function(button){
        var isSelected = button.getAttribute('data-view') === view;
        button.classList.toggle('is-active', isSelected);
        button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
    }

    function normalizeBrand(value){
      return String(value || '')
        .toLowerCase()
        .replace(/&amp;/g, 'and')
        .replace(/&/g, 'and')
        .replace(/[^a-z0-9]+/g, '');
    }

    function getSelectedBrands(){
      return Array.prototype.slice.call(brandChecks)
        .filter(function(input){ return input.checked; })
        .map(function(input){
          var label = input.closest('[data-brand-name]');
          return normalizeBrand((label && label.getAttribute('data-brand-name')) || input.value || '');
        })
        .filter(Boolean);
    }

    function applyBrandFilter(){
      var selected = getSelectedBrands();
      cards.forEach(function(card){
        var brandSearchText = normalizeBrand(card.getAttribute('data-product-brand-search') || ((card.getAttribute('data-product-vendor') || '') + ' ' + (card.getAttribute('data-product-title') || '')));
        var matches = !selected.length || selected.some(function(brand){
          return brandSearchText.indexOf(brand) > -1;
        });
        card.hidden = !matches;
        card.classList.toggle('is-brand-hidden', !matches);
      });
    }

    setView('grid');

    viewButtons.forEach(function(button){
      button.addEventListener('click', function(){
        setView(button.getAttribute('data-view') || 'grid');
      });
    });

    if (sortSelect) {
      // Shopify sorts the complete result set before pagination.
      var sortUrl = new URL(window.location.href);
      var sortValue = sortUrl.searchParams.get('sort_by') || sortSelect.getAttribute('data-current-sort');
      if (sortValue !== 'title-ascending' && sortValue !== 'title-descending') {
        sortUrl.searchParams.set('sort_by', 'title-ascending');
        sortUrl.searchParams.delete('page');
        window.location.replace(sortUrl.toString());
        return;
      }
      sortSelect.value = sortValue;
      sortSelect.addEventListener('change', function(){
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    }

    page.addEventListener('change', function(event){
      if (event.target && event.target.matches('[data-brand-filter]')) applyBrandFilter();
    });
    if (clearBrands) {
      clearBrands.addEventListener('click', function(){
        brandChecks.forEach(function(input){ input.checked = false; });
        applyBrandFilter();
      });
    }
    if (brandSearch) {
      brandSearch.addEventListener('input', function(){
        var query = normalizeBrand(brandSearch.value);
        page.querySelectorAll('[data-brand-option]').forEach(function(option){
          var text = normalizeBrand(option.textContent);
          option.style.display = !query || text.indexOf(query) > -1 ? '' : 'none';
        });
      });
    }
  });

});
// v13.39 product-page store availability selector
(function(){
  function initStoreAvailabilityPanel(panel){
    var selector = panel.querySelector('[data-store-selector]');
    var selectedCards = Array.prototype.slice.call(panel.querySelectorAll('[data-store-selected]'));
    var rows = Array.prototype.slice.call(panel.querySelectorAll('[data-store-row]'));
    function selectStore(index){
      index = String(index || '0');
      selectedCards.forEach(function(card){ card.classList.toggle('is-hidden', card.getAttribute('data-store-selected') !== index); });
      rows.forEach(function(row){ var isSelected = row.getAttribute('data-store-row') === index; row.classList.toggle('is-active', isSelected); row.classList.toggle('is-selected-hidden', isSelected); });
      if (selector && selector.value !== index) selector.value = index;
    }
    if (selector) selector.addEventListener('change', function(){ selectStore(selector.value); });
    rows.forEach(function(row){ row.addEventListener('click', function(){ selectStore(row.getAttribute('data-store-row')); }); });
    selectStore(selector ? selector.value : '0');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){
      document.querySelectorAll('[data-store-availability-panel]').forEach(initStoreAvailabilityPanel);
    });
  } else {
    document.querySelectorAll('[data-store-availability-panel]').forEach(initStoreAvailabilityPanel);
  }
})();

// v14.10 product gallery thumbnails.
(function(){
  function initProductGallery(){
    document.querySelectorAll('[data-product-thumbnails]').forEach(function(wrapper){
      var panel = wrapper.closest('.product-gallery-panel');
      if (!panel || wrapper.getAttribute('data-product-gallery-ready') === '1') return;
      wrapper.setAttribute('data-product-gallery-ready', '1');
      var mainImg = panel.querySelector('[data-product-main-image-element]');
      if (!mainImg) return;
      wrapper.querySelectorAll('[data-product-thumb]').forEach(function(button){
        button.addEventListener('click', function(event){
          event.preventDefault();
          var src = button.getAttribute('data-full-src');
          var alt = button.getAttribute('data-alt') || '';
          if (!src) return;
          mainImg.setAttribute('src', src);
          mainImg.setAttribute('alt', alt);
          wrapper.querySelectorAll('[data-product-thumb]').forEach(function(item){ item.classList.remove('is-active'); });
          button.classList.add('is-active');
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initProductGallery);
  else initProductGallery();
})();
